import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

interface ServiceCard {
  img: string;
  alt: string;
  title: string;
  route: string; // 👈 Ruta para la navegación
}

@Component({
  selector: 'app-our-services',
  standalone: true,
  imports: [CommonModule, RouterLink], // 👈 RouterLink importado
  templateUrl: './our-services.component.html',
  styleUrl: './our-services.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OurServicesComponent implements AfterViewInit {
  @ViewChild('carouselTrack') carouselTrack!: ElementRef<HTMLElement>;

  services: ServiceCard[] = [
    {
      img: '/assets/Tarjetas servicios/1 Financ mercado.jpg',
      alt: 'Financiamiento y Mercado de Capitales',
      title: 'Financiamiento y Mercado de Capitales',
      route: '/servicios/financiamiento',
    },
    {
      img: '/assets/Tarjetas servicios/2 Tesoreria.jpg',
      alt: 'Tesorería y Gestión del Capital del Trabajo',
      title: 'Tesorería y Gestión del Capital del Trabajo',
      route: '/servicios/tesoreria',
    },
    {
      img: '/assets/Tarjetas servicios/3 external CFO.jpg',
      alt: 'External CFO',
      title: 'External CFO (Outsourcing Financiero)',
      route: '/servicios/external-cfo',
    },
    {
      img: '/assets/Tarjetas servicios/4 capacitacion.jpg',
      alt: 'Capacitación Educativa y Empresarial',
      title: 'Capacitación Educativa y Empresarial',
      route: '/servicios/capacitacion',
    },
    {
      img: '/assets/Tarjetas servicios/5 COMEX.jpg',
      alt: 'Comercio Exterior',
      title: 'Comercio Exterior (COMEX)',
      route: '/servicios/comex',
    },
    {
      img: '/assets/Tarjetas servicios/6 Consultoria.jpg',
      alt: 'Consultoría Fiscal y Legal',
      title: 'Consultoría Fiscal y Legal',
      route: '/servicios/consultoria-fiscal',
    },
    {
      img: '/assets/Tarjetas servicios/7 Servicios Especializados.jpg',
      alt: 'Servicios Especializados',
      title: 'Servicios Especializados',
      route: '/servicios/servicios-especializados',
    },
  ];

  extendedServices: ServiceCard[] = [
    ...this.services,
    ...this.services,
    ...this.services,
  ];

  private readonly realSetLength = this.services.length;
  private absoluteIndex = this.realSetLength;
  private isAnimating = false;
  private readonly ANIMATION_MS = 450;

  ngAfterViewInit(): void {
    requestAnimationFrame(() => {
      this.scrollToIndex(this.absoluteIndex, false);
    });
  }

  // 👇 Ya no recibe el container como parámetro, usa el @ViewChild directamente
  scroll(direction: 'left' | 'right') {
    if (this.isAnimating) return;
    this.isAnimating = true;

    const container = this.carouselTrack.nativeElement;
    const delta = direction === 'right' ? 1 : -1;
    const nextIndex = this.absoluteIndex + delta;
    this.scrollToIndex(nextIndex, true);

    setTimeout(() => {
      let finalIndex = nextIndex;
      if (nextIndex < this.realSetLength) {
        finalIndex = nextIndex + this.realSetLength;
        this.scrollToIndex(finalIndex, false);
      } else if (nextIndex >= this.realSetLength * 2) {
        finalIndex = nextIndex - this.realSetLength;
        this.scrollToIndex(finalIndex, false);
      }
      this.absoluteIndex = finalIndex;
      this.isAnimating = false;
    }, this.ANIMATION_MS);
  }

  private scrollToIndex(index: number, smooth: boolean) {
    const container = this.carouselTrack.nativeElement;
    const cards = container.querySelectorAll('.service-card');
    const target = cards[index] as HTMLElement | undefined;
    if (!target) return;

    container.scrollTo({
      left: target.offsetLeft,
      behavior: smooth ? 'smooth' : 'auto',
    });
  }
}